import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { base64Validator, dateValidator, WRAPPED_AES_CRYPTO_KEY_BASE64_LENGTH, } from '#validation';
export const ServiceIdentityCreateSchema = z.object({
    eAccountKeyByServiceIdentitySecretKey: base64Validator({
        requiredError: 'internal.key.required',
        length: {
            len: WRAPPED_AES_CRYPTO_KEY_BASE64_LENGTH,
            error: 'internal.key.length',
        },
        invalidFormatError: 'internal.key.base64',
    }),
    isSingleUse: z.boolean().default(false),
    expiresAt: dateValidator({
        requireFutureDate: {
            error: 'serviceIdentity.expiresAt.futureOnly',
        },
    }).optional(),
});
export class ServiceAccountIdentityCreateDto extends createZodDto(ServiceIdentityCreateSchema) {
}
